import styled from 'styled-components';

export const Container = styled.div<{ $image: string }>`
    padding: 12px 16px;
    height: 100%;
    max-height: 450px;
    background:
        linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 181.4%),
        url(${({ $image }) => $image}) center / cover no-repeat;

    border-radius: ${({ theme }) => `${theme['border-radius-medium']}px`};
    margin-bottom: 24px;
    cursor: pointer;
`;

export const Tag = styled.div`
    border-radius: ${({ theme }) => `${theme['border-radius-small']}px`};
    width: fit-content;
    padding: 4px 8px;
    background-color: ${({ theme }) => theme['primary-default']};
    margin-bottom: 60px;
`;

export const Title = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
    margin-bottom: 2px;
`;
